// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/_variables.scss
// module id = Jrxx
// module chunks = 1